import axios from "axios";
import { Base_URL } from "../url";

// ======================= PROJECT SECTOR APIs =======================

/**
 * Get all sectors by Organisation ID
 * @param {number} organisationId - Organisation ID (2001, 8001, 9001-9006)
 * @returns {Promise<Array>} List of sectors for the specified organisation
 */
export const getSectorsByOrganisation = async (organisationId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectSectorMaster/GetByOrganisation/${organisationId}`,
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return [];
    }
    console.error("Error fetching sectors by organisation:", error);
    throw error.response?.data || "Error fetching sectors by organisation!";
  }
};

/**
 * Get a specific sector by GUID
 * @param {string} guid - The Sector GUID
 * @returns {Promise<Object>} Sector details for the specified GUID
 */
export const getSectorByGuid = async (guid) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectSectorMaster/GetByGuid/${guid}`,
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    console.error("Error fetching sector by GUID:", error);
    throw error.response?.data || "Error fetching sector by GUID!";
  }
};

/**
 * Get all sectors for all organisations
 * @returns {Promise<Array>} List of all sectors across all organisations
 */
export const getAllSectors = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ProjectSectorMaster/GetAll`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all sectors:", error);
    throw error.response?.data || "Error fetching all sectors!";
  }
};

/**
 * Get sector by ID
 * @param {number} id - Sector ID
 * @returns {Promise<Object>} Sector details
 */
export const getSectorById = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectSectorMaster/GetById/${id}`,
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    console.error("Error fetching sector by ID:", error);
    throw error.response?.data || "Error fetching sector by ID!";
  }
};

// ======================= END PROJECT SECTOR APIs =======================
